/**
* @version GENERATOR_VERSION::20200504
* @DateTime 2021-04-20T19:25:48.981
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import BasicLayout from '@/layouts/basic-layout';

const meta = {
auth: true
};

const pre = 'rentmanage-renthousetraffic-'

export default 
{
path: '/rentmanage/renthousetraffic',
name: 'rentmanage-renthousetraffic',
redirect: {
name: '${pre}-index'
}
,

meta:{
...meta,
},

component: BasicLayout ,
children:
[
{
path: 'index',
name: '${pre}renthousetraffic-index',

meta:{
...meta,
title: '房源交通'
},

component: () => import('@/pages/rentmanage/renthousetraffic/index') ,
},
{
path: 'detail-edit/:id',
name: '${pre}renthousetraffic-detail-edit',
auth: [
'hidden'
],

meta:{
...meta,
title: '房源交通编辑'
},

component: () => import('@/pages/rentmanage/renthousetraffic/detail-edit') ,
},
{
path: 'detail-edit',
name: '${pre}renthousetrafficdetail-create',
auth: [
'hidden'
],

meta:{
...meta,
title: '房源交通新增'
},

component: () => import('@/pages/rentmanage/renthousetraffic/detail-edit') ,
},
{
path: 'detail-view/:id',
name: '${pre}renthousetrafficView',
auth: [
'hidden'
],

meta:{
...meta,
title: '房源交通详情查看'
},

component: () => import('@/pages/rentmanage/renthousetraffic/detail-view') ,
},
]
};
